export const GET_APPS_INFO_START = 'GET_APPS_INFO_START';
export const GET_APPS_INFO_SUCCESS = 'GET_APPS_INFO_SUCCESS';
export const GET_APPS_INFO_FAILURE = 'GET_APPS_INFO_FAILURE';